module.exports = __webpack_public_path__ + "media/images/home/cpg-9aa0743273be749fe6e859f20f64276d.png";